// options: https://github.com/SortableJS/Sortable?tab=readme-ov-file#options
import {Controller} from '@hotwired/stimulus'
import Sortable from 'sortablejs'

export default class extends Controller {
  static targets = ['list']

  connect() {
    if (!this.hasListTarget || this.sortable)
      return

    // Defer initialization to next frame so layout can settle and we don’t block first paint
    requestAnimationFrame(() => {
      if (this.sortable || !this.hasListTarget)
        return

      this.initializeSortable()
    })
  }

  initializeSortable() {
    const groupName = this.element.dataset.sortableGroup

    this.sortable = Sortable.create(this.listTarget, {
      group: groupName,
      handle: '.js-sortable-handle',
      animation: 150,
      ghostClass: 'sortable-ghost', // TODO: css classname - style this or remove - it can be renamed
      chosenClass: 'sortable-chosen', // TODO: css classname - style this or remove - it can be renamed
      dragClass: 'sortable-drag', // TODO: css classname - style this or remove - it can be renamed
      onEnd: (evt) => this.onEnd(evt),
      filter: 'textarea, input, [contenteditable]',
      preventOnFilter: false,
      onFilter: (evt) => evt.preventDefault(),
    })
  }

  // TODO: re-enable disconnect once the projects lists can handle it without disconnecting mid-drag
  // disconnect() {
  //   this.sortable?.destroy()
  //   this.sortable = null
  // }

  onEnd() {
    const orderedDomIds = Array.from(this.listTarget.children).map((child) => child.id)
    const path = this.element.dataset.sortablePath
    const sortContext = this.element.dataset.sortContext

    this.constructor.updateOrder(path, orderedDomIds, sortContext)
  }

  static updateOrder(path, orderedDomIds, context) {
    return fetch(path, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
      },
      body: JSON.stringify({ordered_dom_ids: orderedDomIds, sort_context: context}),
    })
      .then((response) => {
        if (!response.ok)
          throw new Error('Failed to update order')

        return true
      })
      .catch((err) => {
        console.error('Failed to update order', err) // eslint-disable-line no-console
        return false
      })
  }
}
